export default __webpack_public_path__ + "static/media/most-popular-1.f3042dc5.jpg";